<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <div class="row mb-2">
        <div class="col">
          <h1 class="text-white pt-3 px-3">
            สรุปข้อมูลการขายสินค้า
            <small>(ไม่รวมการส่งพัสดุ)</small>
          </h1>
          <p
            class="text-white pb-0 px-3"
          >แสดงข้อมูลการขายสินค้าทั้งหมดของสาขา ไม่รวมการส่งพัสดุ โดยสามารถเลือกวันที่สามารถมาแสดงผลได้</p>
        </div>
        <div class="col-12 col-md-12 col-lg-5 align-self-center px-3 text-right">
          <h1 class="display-3 text-white">
            <small>ยอดขายทั้งหมด :</small>
            {{total | numFormat('0,0.00')}}
            <small>บาท</small>
          </h1>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7 mb-5">
      <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <div class="row justify-content-between">
                <div class="col-12 col-md-12 col-lg-12 col-xl-6">
                  <b-form-group
                    id="input-group-1"
                    label="ค้นหาวันที่ขายสินค้า (วันเริ่มต้น - วันสุดท้าย)"
                    label-for="input-1"
                    class="mb-0"
                  >
                    <div class="row">
                      <div class="col-12 col-md-8 col-lg-8">
                        <date-range-picker
                          class="w-100"
                          :opens="'center'"
                          @start-selection="logEvent('startSelection', $event)"
                          @finish-selection="logEvent('finishSelection', $event)"
                          :min-date="minDate"
                          :max-date="maxDate"
                          :singleDatePicker="false"
                          :appendToBody="true"
                          :ranges="false"
                          :closeOnEsc="false"
                          :autoApply="true"
                          :locale-data="{ format: 'dd/mm/yyyy' }"
                          v-model="filtersDate">
                        </date-range-picker>
                      </div>
                      <div class="col-12 col-md-3 col-lg-2">
                        <button class="btn btn-info btn-sm-res" v-on:click="getReportProduct()">
                          <i class="fa fa-search"></i>
                        </button>
                      </div>
                    </div>
                  </b-form-group>
                  <hr class="d-md-block d-lg-none" />
                </div>

                <div class="col-12 col-md-6 col-lg-6 col-xl-4 mb-3">
                  <b-form-group
                    id="input-group-1"
                    label="ค้นหาข้อมูล"
                    label-for="input-1"
                    class="mb-0"
                  >
                    <b-form-input
                      id="input-1"
                      type="text"
                      v-model="filter"
                      placeholder="ค้นหาข้อมูล"
                    ></b-form-input>
                  </b-form-group>
                  <hr class="d-block d-md-none d-lg-none mb-0" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 col-xl-2">
                  <b-form-group label="Export File" class="mb-0 pb-2">
                    <div class="btn-group btn-sm-res btn-export" role="group" aria-label="Basic example">
                      <vue-excel-xlsx
                        :data="formatExcel"
                        :columns="column"
                        :filename="'สรุปข้อมูลขายสินค้า '+date_excel"
                        :sheetname="'สรุปข้อมูลขายสินค้า '+date_excel"
                        >
                        excel           
                      </vue-excel-xlsx>
                      <b-button
                        variant="info"
                        class="btn-sm-res"
                        @click="$htmlToPaper('tablePrint')"
                      >print</b-button>
                    </div>
                  </b-form-group>
                </div>
              </div>
            </div>
            <div id="tablePrint">
              <b-table
                show-empty
                responsive
                :items="itemFilter"
                :fields="fields"
                :filter="filter"
                :busy="busy"
                class="scroll-bar-pop"
                foot-clone
                >
                <div slot="table-busy" class="text-center">
                  <BlockUI>
                    <div class="loader"></div>
                  </BlockUI>
                </div>
                <template slot="index" slot-scope="data">{{ data.index+1 }}</template>
                <template slot="created_at" slot-scope="row">{{ row.item.created_at.date | dateFormat }}</template>
                <template slot="status" slot-scope="row">
                    <b-badge :variant="statusInfo(row.item).color +' report'" >
                        {{statusInfo(row.item).status}}
                    </b-badge>
                </template>
                <template slot="rate" slot-scope="row">{{ row.item.rate | numFormat('0,0.00') }}</template>
                <template slot="fee" slot-scope="row">{{ row.item.fee * row.item.num | numFormat('0,0.00') }}</template>
                <template slot="price" slot-scope="row">{{ row.item.price | numFormat('0,0.00') }}</template>
                <template slot="num" slot-scope="row">{{ row.item.num | numFormat('0,0') }}</template>
                <template
                  slot="total"
                  slot-scope="row"
                >{{ row.item.price * row.item.num | numFormat('0,0.00') }}</template>
                <template slot="remark" slot-scope="row">
                  {{ (row.item.remark) ? (row.item.remark) : '-' }}
                </template>
                <template slot="FOOT_index">รวม</template>
                <template slot="FOOT_created_at"> &nbsp;</template>
                <template slot="FOOT_status"> &nbsp;</template>
                <template slot="FOOT_name"> &nbsp;</template>
                <template slot="FOOT_status"> &nbsp;</template>
                <template slot="FOOT_rate">{{footerTotal.rate| numFormat('0,0.00')}}</template>
                <template slot="FOOT_fee">{{footerTotal.fee| numFormat('0,0.00')}}</template>
                <template slot="FOOT_price">{{footerTotal.price| numFormat('0,0.00')}}</template>
                <template slot="FOOT_num">{{footerTotal.num| numFormat('0,0')}}</template>
                <template slot="FOOT_total">{{footerTotal.totals| numFormat('0,0.00')}}</template>
                <template slot="FOOT_remark"> &nbsp;</template>
                <template slot="FOOT_cashier">&nbsp;</template>

              </b-table>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import validatePop from "../../plugins/validatePop.js";
import { statusCourier, statusInfo } from "@/plugins/statusCourier.js"
import { dateLimitRanges } from "@/plugins/datePicker.js"
import moment from "moment";
const API_URL = process.env.VUE_APP_API;

export default {
  name: "reportproduct",
  data() {
    return {
      itemProduct: [],
      userLogin: "",
      busy: true,
      minDate: null,
      maxDate: moment().format("YYYY-MM-DD"),
      filter: null,
      filtersDate: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      date_excel: moment().format("DD-MM-YYYY"),
      statusCourier:statusCourier,
      statusInfo: statusInfo
    };
  },
  mounted() {
    this.userLogin = JSON.parse(localStorage.getItem("user"))
    this.getReportProduct();
  },
  filters: {
    dateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
  },
  methods: {
    logEvent( event , date ){
        const { minDate , maxDate } =  dateLimitRanges(event, date);
        this.minDate = minDate
        this.maxDate = maxDate
    },
    getReportProduct() {
      this.busy = true;
      this.$http
        .post(
          API_URL + "/shop/check",
          {
            start: moment(this.filtersDate.startDate).format("YYYY-MM-DD"),
            end: moment(this.filtersDate.endDate).format("YYYY-MM-DD"),
            type: "item"
          },
          {
            headers: {
              Token: localStorage.getItem("access_token")
            }
          }
        )
        .then(res => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            if (checkError.notices == "token is expired") {
              this.$router.push("/logout");
            }
            this.busy = false;
            this.showErrorModal(checkError.msg);
            return false;
          }
          this.busy = false;
          this.itemProduct = res.data.data.items
          this.itemProduct.forEach((data, i)=>{
            this.itemProduct[i].date_created = data.created_at.date
            this.itemProduct[i].sum = data.price*data.num
            this.itemProduct[i].profit = data.fee*data.num
          });
          this.totalRows = this.itemProduct.length;
        });
    },
    // getDateNow(myDate) {
    //   var month = ("0" + (myDate.getMonth() + 1)).slice(-2);
    //   var date = ("0" + myDate.getDate()).slice(-2);
    //   var year = myDate.getFullYear();
    //   var formattedDate = year + "-" + month + "-" + date;
    //   this.filtersDate.startDate = formattedDate;
    //   this.filtersDate.endDate = formattedDate;
    // },
    isAdmin() {
      return this.userLogin.role === "admin";
    },
    isSuperAdmin() {
      return this.userLogin.role === "superadmin";
    },
    showErrorModal(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "ERROR",
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        okTitle: "ลองอีกครั้ง",
        contentClass: "modal-errors",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true
      });
    },
  },
  computed: {
    itemFilter() {
      return this.itemProduct.filter(item => {
        if(!this.filter){
          return true
        }
        else if (this.filter){
        return Object.values(item).some((val)=>{
          return String(val).toLowerCase().includes(this.filter.toLowerCase())
         })
        }
      });
    },
    total() {
      return this.itemFilter.reduce((total, product) => {
        return (product.status != 'CANCEL' ) ? total + Number(product.price) * Number(product.num) : total;
      }, 0);
    },
    footerTotal() {
      let total = { price: 0, rate: 0, fee: 0, num:0, totals:0, };
      this.itemFilter.forEach(item => {
        if( item.status != 'CANCEL' ){
          total.price += +item.price;
          total.rate += +item.rate;
          total.fee += +item.fee*item.num;
          total.num += +item.num;
          total.totals += +item.price*item.num;
        }
      });
      return total;
    },
    column() {
      let columns =  [
                    {
                        label: "วันที่สร้างรายการ",
                        field: "date_created",
                        dataFormat: value => {
                          return (value) ? `${this.$options.filters.dateFormat(value)}` : 'รวม';
                        }
                    },
                    {
                        label: "สถานะ",
                        field: "status",
                        dataFormat: value => {
                          return (value) ? this.statusCourier(value).status : '';
                        }
                    },
                    {
                        label: "รายละเอียด",
                        field: "name",
                    },
                    {
                        label: "ต้นทุน",
                        field: "rate",
                        dataFormat: value => {
                          return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                        } 
                    },
                    {
                        label: "กำไร",
                        field: "profit",
                        dataFormat: value => {
                          return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                        }
                    },
                    {
                        label: "ราคาขาย",
                        field: "price",
                        dataFormat: value => {
                          return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                        } 
                    },
                    {
                        label: "จำนวน",
                        field: "num",
                        dataFormat: value => {
                          return `${this.$options.filters.numFormat(value,'0,0')}`;
                        } 
                    },
                    {
                        label: "รวม",
                        field: "sum",
                        dataFormat: value => {
                          return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                        } 
                    },
                    {
                        label: "หมายเหตุ",
                        field: "remark",
                        dataFormat: value => {
                          return (value) ? value : '-';
                        }
                    },
                    {
                        label: "cashier",
                        field: "cashier",
                    },
            ]
            if ( this.isAdmin() || this.isSuperAdmin() ) {
              return columns
            }else{  
              return columns.filter(function (col) {
                return [ 'ต้นทุน' , 'กำไร' ].indexOf(col.label) < 0
              })
            }
    },
    fields(){ 
      let fields = [
        { key: "index", label: "ลำดับ", sortable: true },
        { key: "created_at", label: "วันที่สร้างรายการ", sortable: true },
        { key: "status", label: "สถานะ", sortable: true },
        {
          key: "name",
          label: "รายละเอียด",
          sortable: true,
          class: "text-center"
        },
        { key: "rate", label: "ต้นทุน/ชิ้น", sortable: true },
        { key: "price", label: "ราคาขาย/ชิ้น", sortable: true },
        { key: "num", label: "จำนวนทั้งหมด", sortable: true },
        { key: "fee", label: "กำไร/ชิ้น", sortable: true },
        { key: "total", label: "ราคาทั้งหมด", sortable: true },
        { key: "remark", label: "หมายเหตุ", sortable: true , class: "text-center"},
        { key: "cashier", label: "cashier", sortable: true }

      ]
      if( !this.isAdmin() && !this.isSuperAdmin() ){
          return fields.filter(function (col) {
               return [ 'rate' , 'fee' ].indexOf(col.key) < 0

          })
      }
      return fields
    },
    formatExcel(){
      let data = [ ...this.itemFilter ];
      if(this.itemFilter.length > 0){
        let format = {
          date_created:'',
          status:'',
          name:'',
          rate: this.footerTotal.rate,
          profit: this.footerTotal.fee,
          price: this.footerTotal.price,
          num: this.footerTotal.num,
          sum: this.footerTotal.totals,
          remark:'',
          cashier:''
        }
        data.push(format);
      }
      return data;
    }
  }
};
</script>

<style></style>
